/**
 * Miss row for Der · Die · Das.
 *
 * The shared row would print the word's translation, which is not what you got
 * wrong here — this app never asked what the word means. The answer is the
 * article, so the row shows the word with its correct article in the gender
 * colour, and your wrong pick underneath.
 */
import { MissRowFrame, UserAnswer } from '@/components/practice/SharedMissRow';
import type { NounsPayload } from '@/core/types';
import { articleText } from '@/lib/gender';

import type { MissRowProps } from '../types';

export function MissRow({ card, user_answer }: MissRowProps<NounsPayload>) {
  const article = card.payload.article;

  return (
    <MissRowFrame article={article}>
      <span className="font-display text-base font-semibold">
        <span className={articleText(article)}>{article} </span>
        {card.de}
      </span>
      <UserAnswer user_answer={user_answer} verb="chose" />
    </MissRowFrame>
  );
}
